
















import Vue from "vue";
import CharacterForm from "@/components/organisms/CharacterForm.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { callApi } from "@/lib/api";
import { submitImage } from "@/lib/image-save";
import isMobile from "ismobilejs";

export default Vue.extend({
  components: { CharacterForm, ImageSelector },
  props: {
    novelId: String,
    characterFolderId: String,
  },
  data() {
    return {
      model: {
        detail: [],
        additionalColumn: [],
      },
      image: "",
      saving: false,
    };
  },
  computed: {
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      if (this.saving) {
        return;
      }
      try {
        this.saving = true;
        const { novelId, characterFolderId, image } = this;
        const CreateCharacter = `
        mutation CreateCharacter($input: CreateCharacterInput!) {
          createCharacter ( input: $input ) {
            characterId
            novelId
          }  
        }`;
        const { additionalColumn } = this.model;
        this.model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);
        const { createCharacter } = await callApi(CreateCharacter, {
          input: {
            novelId,
            characterFolderId,
            ...this.model,
            image,
          },
        });
        const characterId = createCharacter.characterId;
        await submitImage(`novels/${novelId}/characters/${characterId}.jpg`);

        this.$ga.event("novel", "create-character", "登場人物新規作成", 0);
        this.setModified(false);
        this.$router.push({
          name: "characters",
          params: { novelId, characterId },
        });
      } finally {
        this.saving = false;

        this.$notify({
          title: "保存しました",
          type: "success",
        });
      }
    },
  },
});
